(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Product-related-recommendations"]) return;
  try {
    
 

  
  class ProductRelatedRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-related-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-related-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-related-recommendations', ProductRelatedRecommendations);

      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["business-contact"] && !Shopify.designMode) return;
  try {
    
(function(){
  var form = document.getElementById('EtoolstoreContactForm');
  if(!form) return;

  var params = new URLSearchParams(window.location.search);
  var type = params.get('type');
  var product = params.get('product');

  var typeSelect = document.getElementById('EtoolstoreContactType');
  var productInput = document.getElementById('EtoolstoreContactProduct');

  var types = {
    product: 'Product availability',
    bulk: 'Bulk / business quotation',
    spares: 'Spares / replacement part',
    order: 'Order / delivery support',
    delivery: 'NCR express delivery / pickup'
  };

  if(typeSelect && type && types[type]) typeSelect.value = types[type];
  if(productInput && product) productInput.value = product;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-spotlight"] && !Shopify.designMode) return;
  try {
    
(function(){
  function shuffleSpotlight(root){
    if(root.dataset.shuffleInitialised === 'true') return;
    root.dataset.shuffleInitialised = 'true';
    var count = parseInt(root.dataset.supportCount || '4', 10);
    var container = root.querySelector('.et-collection-spotlight__products');
    if(!container) return;
    var items = Array.prototype.slice.call(container.querySelectorAll('[data-spotlight-product]'));
    if(items.length <= count) {
      items.forEach(function(item){ item.hidden = false; });
      return;
    }
    for(var i = items.length - 1; i > 0; i--){
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = items[i];
      items[i] = items[j];
      items[j] = tmp;
    }
    items.forEach(function(item,index){
      container.appendChild(item);
      item.hidden = index >= count;
    });
  }
  document.querySelectorAll('[data-spotlight-shuffle]').forEach(shuffleSpotlight);
  document.addEventListener('shopify:section:load', function(event){
    var root = event.target.querySelector('[data-spotlight-shuffle]');
    if(root) shuffleSpotlight(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  $('.header__heading-logo.removesrcset').removeAttr('srcset');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["personal-product-banner"] && !Shopify.designMode) return;
  try {
    
(function(){
  function cookieValue(name){
    var prefix = name + '=';
    var parts = document.cookie ? document.cookie.split(';') : [];
    for(var i=0;i<parts.length;i++){
      var part = parts[i].trim();
      if(part.indexOf(prefix) === 0) return decodeURIComponent(part.substring(prefix.length));
    }
    return '';
  }
  function money(cents){
    if(typeof cents !== 'number') return '';
    return new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:2}).format(cents/100);
  }
  function updateBanner(root, product){
    var title = root.querySelector('[data-personal-title]');
    var eyebrow = root.querySelector('[data-personal-eyebrow]');
    var text = root.querySelector('[data-personal-text]');
    var price = root.querySelector('[data-personal-price]');
    var link = root.querySelector('[data-personal-link]');
    var mediaLink = root.querySelector('[data-personal-link-media]');
    var image = root.querySelector('.et-personal-banner__image');
    var placeholder = root.querySelector('.et-personal-banner__placeholder');
    var productUrl = product.url || ('/products/' + product.handle);
    if(eyebrow) eyebrow.textContent = 'Continue where you left off';
    if(title) title.textContent = product.title || '';
    if(text) text.textContent = product.vendor ? 'You recently viewed this ' + product.vendor + ' product. Pick up where you left off.' : 'You recently viewed this product. Pick up where you left off.';
    if(price) price.textContent = money(product.price);
    if(link) link.href = productUrl;
    if(mediaLink) mediaLink.href = productUrl;
    var imageUrl = product.featured_image || (product.images && product.images.length ? product.images[0] : '');
    if(imageUrl){
      if(!image){
        image = document.createElement('img');
        image.className = 'et-personal-banner__image';
        image.loading = 'lazy';
        if(placeholder) placeholder.replaceWith(image);
        else if(mediaLink) mediaLink.appendChild(image);
      }
      image.src = imageUrl;
      image.alt = product.title || '';
    }
  }
  function initialise(root){
    var cookieName = root.dataset.cookieName || 'shopify_recently_viewed';
    var raw = cookieValue(cookieName);
    if(!raw) return;
    var handles = raw.split(' ').filter(Boolean).slice(0,5);
    function tryHandle(index){
      if(index >= handles.length) return;
      fetch('/products/' + encodeURIComponent(handles[index]) + '.js',{credentials:'same-origin'})
        .then(function(response){if(!response.ok) throw new Error('not found');return response.json();})
        .then(function(product){if(product && product.available !== false) updateBanner(root, product);else tryHandle(index+1);})
        .catch(function(){tryHandle(index+1);});
    }
    tryHandle(0);
  }
  document.querySelectorAll('[data-personal-banner]').forEach(initialise);
  document.addEventListener('shopify:section:load',function(event){
    var root = event.target.querySelector('[data-personal-banner]');
    if(root) initialise(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

    $(document).ready(checkContainer);

function checkContainer () {
  if($('.product-recommendations ul.grid.product-grid li.grid__item').is(':visible')){ //if the container is visible on the page
    createGrid();  //Adds a grid to the html
  } else {
    setTimeout(checkContainer, 50); //wait 50 ms, then try again
  }
}
   function createGrid(){
     $top = 0;
     $count = 0;
     $height = 0;
     $('.product-recommendations ul.grid.product-grid li.grid__item').each(function(){
       $count ++;
       $c_height = $(this).find('div.card--card.card--media>div.card__content>div.card__information').outerHeight();//$(this ).outerHeight();
       if($c_height > $height)
         $height = $c_height;
     });
     $height = $height+'px';
     //console.log($height);
     $('.product-recommendations ul.grid.product-grid li.grid__item div.card--card.card--media>div.card__content>div.card__information').css('height',$height);
     //$('.product-recommendations ul.grid.product-grid li.grid__item').css('min-height',$height);
     $bco = 4;
     $cco = 3;
     $dco = 2;
     if($count > 5){
       $count = 5;
     }
     if($count < 4){
       $bco = $count;
     }
     if($count < 3){
       $cco = $count;
     }
     if($count < 2){
       $dco = $count;
     }
     //if($count > 5){
  $('.product-recommendations .grid.product-grid').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: $count,
  centerMode: false,
  centerPadding: '40px',
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1196,
      settings: {
        slidesToShow: $count,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 1195,
      settings: {
        slidesToShow: $bco,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 1099,
      settings: {
        slidesToShow: $cco,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: $dco,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
   // }
   }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-spareparts-collection"]) return;
  try {
    
  class ProductSparepartsCollection extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-spareparts-collection');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-spareparts-collection--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-spareparts-collection', ProductSparepartsCollection);     
  
     
 $('.slider-detailpart-collction .ssfpi').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false, 
          dots: true,
          fade: true,
          autoplay: true,
          autoplaySpeed: 6000
      });
   
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rotating-products"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initialiseRotatingProducts(root){
    if(root.dataset.rotatingInitialised === 'true') return;
    root.dataset.rotatingInitialised = 'true';
    var showCount = parseInt(root.dataset.show || '10', 10);
    if(window.matchMedia('(max-width: 749px)').matches) showCount = Math.min(showCount, 6);
    var grid = root.querySelector('.et-rotating-products__grid');
    if(!grid) return;
    var items = Array.prototype.slice.call(grid.querySelectorAll('[data-rotating-product]'));
    for(var i = items.length - 1; i > 0; i--){
      var j = Math.floor(Math.random() * (i + 1));
      var temp = items[i];
      items[i] = items[j];
      items[j] = temp;
    }
    items.forEach(function(item,index){
      grid.appendChild(item);
      item.hidden = index >= showCount;
    });
  }
  document.querySelectorAll('[data-rotating-products]').forEach(initialiseRotatingProducts);
  document.addEventListener('shopify:section:load', function(event){
    var root = event.target.querySelector('[data-rotating-products]');
    if(root) initialiseRotatingProducts(root);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
